<script setup lang="ts">
import SharedLoadingIndicator from "./SharedLoadingIndicator.vue";

defineProps<{
  visible: boolean;
  text?: string;
}>();
</script>

<template>
  <Teleport to="body">
    <div v-if="visible" class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
      <SharedLoadingIndicator :mt="false" :pb="false" :text="text" />
    </div>
  </Teleport>
</template>
